import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/segments'),
    component: () => import('segments/pages/SegmentsListPage.vue'),
    name: 'segments_index',
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/segments/new'),
    component: () => import('segments/pages/SegmentEditorPage.vue'),
    name: 'segments_new',
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/segments/:id/edit'),
    component: () => import('segments/pages/SegmentEditorPage.vue'),
    name: 'segments_edit',
    meta: { permissions: ['administrator', 'agent'] },
  },
];
